const STORAGE_KEY = "login_redirect_after";

const SKIP_PATH_PREFIXES = [
  "/login",
  "/register",
  "/studentRegister",
  "/teacherRegister",
  "/loginMiddle",
  "/findAccount",
];

/** 校验并规范化登录成功后的站内回跳路径 */
export function normalizeLoginRedirect(redirect) {
  if (redirect == null || redirect === undefined) return "";
  const r = String(redirect).trim();
  if (!r.startsWith("/") || r.startsWith("//")) return "";
  const pathOnly = r.split("?")[0].split("#")[0];
  const skip = SKIP_PATH_PREFIXES.some(
    (p) => pathOnly === p || pathOnly.startsWith(`${p}/`)
  );
  return skip ? "" : r;
}

/** 根据当前路由生成跳转登录页时的 query */
export function getLoginRedirectQuery(fromRoute) {
  const route = fromRoute || {};
  if (route.path === "/login") {
    const existing = normalizeLoginRedirect(
      route.query && route.query.redirect
    );
    return existing ? { redirect: existing } : {};
  }
  const target = normalizeLoginRedirect(route.fullPath || route.path || "");
  return target ? { redirect: target } : {};
}

/** 跳转登录页的路由对象 */
export function buildLoginLocation(fromRoute) {
  return {
    path: "/login",
    query: getLoginRedirectQuery(fromRoute),
  };
}

/** 写入 sessionStorage，供登录成功后回跳 */
export function persistLoginRedirect(redirect) {
  const normalized = normalizeLoginRedirect(redirect);
  if (!normalized) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, normalized);
  } catch (e) {
    /* ignore */
  }
}

/** 读取尚未消费的回跳地址（不清除） */
export function getPendingLoginRedirect(route) {
  const fromQuery = normalizeLoginRedirect(
    route && route.query && route.query.redirect
  );
  if (fromQuery) return fromQuery;
  try {
    return (
      normalizeLoginRedirect(sessionStorage.getItem(STORAGE_KEY)) || ""
    );
  } catch (e) {
    return "";
  }
}

/** 从路由写入 sessionStorage */
export function persistLoginRedirectFromRoute(route) {
  const loc = buildLoginLocation(route);
  const redirect =
    (loc.query && loc.query.redirect) ||
    normalizeLoginRedirect(route && route.fullPath);
  persistLoginRedirect(redirect);
}

/** 登录成功后解析回跳地址，默认首页 */
export function resolveLoginRedirect(route, fallback = "/") {
  const fromQuery = normalizeLoginRedirect(
    route && route.query && route.query.redirect
  );
  if (fromQuery) {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
    return fromQuery;
  }
  try {
    const stored = normalizeLoginRedirect(
      sessionStorage.getItem(STORAGE_KEY)
    );
    if (stored) {
      sessionStorage.removeItem(STORAGE_KEY);
      return stored;
    }
  } catch (e) {
    /* ignore */
  }
  return fallback;
}

/** 提示未登录并跳转登录页（带回跳地址） */
export function promptLogin(vm, message = "请先登录") {
  if (!vm) return;
  persistLoginRedirectFromRoute(vm.$route);
  vm.$message({
    message,
    type: "warning",
  });
  vm.$router.push(buildLoginLocation(vm.$route));
}
